import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-75309a42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pickup-addresses" }
const _hoisted_2 = { class: "mo-form-group mo-form-group--line mo-form-group--required" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Пункт самовывоза", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueSelect = _resolveComponent("VueSelect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_VueSelect, {
        modelValue: _ctx.selectedAddress,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAddress) = $event)),
        options: _ctx.orderStore.pickupAddresses,
        label: "address",
        "onOption:selected": _ctx.select
      }, {
        "no-options": _withCtx(() => [
          _createTextVNode(" Похожих адресов не найдено ")
        ]),
        _: 1
      }, 8, ["modelValue", "options", "onOption:selected"])
    ])
  ]))
}